import { Component, NgModuleRef, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { CapabilityEngineService } from '../capabilityEngine.service';
import { RedirectService } from '../redirect/redirect.service';
import { FormsListService } from './forms-list.service';
import { CookieService } from 'ngx-cookie-service';
import { FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateFolderComponent } from '../create-folder/create-folder.component';
import { MoveTemplatesComponent } from '../move-templates/move-templates.component';
declare const Buffer;
declare var $: any;
@Component({
    selector: 'app-forms-list',
    templateUrl: './forms-list.component.html',
    styleUrls: ['./forms-list.component.scss']
})
export class FormsListComponent implements OnInit {

    formsList: any;
    pageNumber: number = 0;
    sortKey: String;
    sortOrder: String;
    formBuilderUrl: string;
    teamName: String;
    teamId: String;
    templateObj: String;
    maxTemplateLength: String;
    emptyTemplateError = '';
    duplicateTemplateError = '';
    duplicateEmptyTemplate: string = '';
    template_id: string;
    template_name: string;
    publishedFormsCounts: any;
    formTemplateList = true;
    formTemplateGrid = false;
    basedonCapabilities = true;
    formBuilderDetails: any;
    qrLink: any;
    previewQRID: string;

    mainDirectoryTemplates: any = [];
    collectionName;
    directoryList = false;
    dummyTemplate: any;
    subFormArray: any = [];
    showFormName: any;
    duplicateFolder:any;
    directories: any = [];
    collectionId: string = "";
    deleteActionModalRef: any = "";
    constructor(
        private _router: Router,
        private _formsListService: FormsListService,
        private _capabilityEngineService: CapabilityEngineService,
        private _redirectService: RedirectService,
        private _authService: AuthService,
        private _activatedRoute: ActivatedRoute,
        private _cookieService: CookieService,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
        let userRole = localStorage.getItem('userRole');
        if (userRole === 'supervisor') {
            this.basedonCapabilities = false;
        } else {
            this.basedonCapabilities = true;
        }
        const pathData = this._activatedRoute.data['_value'];
        if (this.canPerform(pathData.capabilities)) {
            this.onScroll();

            this.sortKey = 'name';
            this.sortOrder = 'asc';
            this.teamName = localStorage.getItem('teamName');
            this.teamId = localStorage.getItem('teamId');

            this.formBuilderDetails = {
                'appId': encodeURIComponent(environment.formBuilder.appId),
                'x-header-authtoken': encodeURIComponent(this._authService.getAuthToken()),
                'x-header-refreshtoken': encodeURIComponent(this._authService.getRefreshToken()),
                'redirectUrl': encodeURIComponent(window.location.href.toString()),
                'formElementsEndPoint': encodeURIComponent('/api/assets/team/')
            }

            this.formBuilderUrl = environment.formBuilder.serverUrl + '/api/v1/verifyTokens?' + 'data='
                + this.encode(this.formBuilderDetails);
        }

        const layout = this._cookieService.get('userpreferences-layout');
        if (layout === '1') {

            this.formTemplateGrid = true;
            this.formTemplateList = false;
        } else {
            this.formTemplateGrid = false;
            this.formTemplateList = true;
        }
    }

    getTagTitle(tag) {
        let tagData = { "DAILY": "Daily", "WEEKLY": "Weekly", "MONTHLY": "Monthly", "QUARTERLY": "Quarterly" };

        return tagData[tag];
    }
    updateUrlWithDirectoryDetails() {

        if (this.dummyTemplate != undefined) {
            this.formBuilderDetails.directory = encodeURIComponent(JSON.stringify(_.pick(this.dummyTemplate, ['_id', 'name'])));

        } else {
            this.formBuilderDetails = {
                'appId': encodeURIComponent(environment.formBuilder.appId),
                'x-header-authtoken': encodeURIComponent(this._authService.getAuthToken()),
                'x-header-refreshtoken': encodeURIComponent(this._authService.getRefreshToken()),
                'redirectUrl': encodeURIComponent(window.location.href.toString()),
                'formElementsEndPoint': encodeURIComponent('/api/assets/team/')
            }
        }
        this.formBuilderUrl = environment.formBuilder.serverUrl + '/api/v1/verifyTokens?' + 'data=' +
            this.encode(this.formBuilderDetails);
    }

    getEditFormTemplate(template) {
        this.formBuilderDetails['taskTemplateId'] = template._id;
        this.formBuilderDetails['formState'] = template.status;
        this.formBuilderUrl = environment.formBuilder.serverUrl + '/api/v1/verifyTokens?' + 'data='
            + this.encode(this.formBuilderDetails);

        window.location.href = this.formBuilderUrl;
    }

    encode(data) {
        const dataString = JSON.stringify(data);
        let buffer = new Buffer(dataString);
        let base64data = buffer.toString('base64');
        return base64data;
    }

    decode(data) {
        let buffer = new Buffer(data, 'base64');
        let dataString = buffer.toString('ascii');
        const dataObj = JSON.parse(dataString);
        return dataObj;
    }

    sort(key) {
        if (key === this.sortKey) {
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortKey = key;
            this.sortOrder = 'asc';
        }
    }

    canPerform(data) {
        return this._capabilityEngineService.canPerform(data);
    }

    nameSort(formList){
        let statusZero:any = _.filter(formList, function (o) { return o.status !== 2});
        statusZero.sort((a, b) => a.name.localeCompare(b.name));
        let statusTwo = _.filter(formList, function (o) { return o.status === 2});
        _.forEach(statusTwo , (value,key)=>{
            statusZero.push(value)
        });
        return statusZero;
    }

    onScroll() {
        this._formsListService.performPagination(this.pageNumber)
            .subscribe((result: any) => {
                console.log(result, 'template');
                if (this.mainDirectoryTemplates.length === 0) {
                    this.mainDirectoryTemplates.push({ templates: _.filter(result.data, function (o) { return !o.directory; }), directory: _.filter(result.data, function (o) { return o.directory; }) })
                    if (!this.formsList) {
                        this.qrLink = environment.QR_LINK;
                        this.formsList = this.mainDirectoryTemplates[0].templates;
                        this._formsListService.getTemplateDirecotries().subscribe(
                            (res: any) => {
                                this.directories = [...res.data];

                                if (!this.formsList.type) {
                                    _.forEach(res.data, (val, key) => {
                                        this.formsList.push({ _id: val._id, name: val.name, type: 'folder', updatedBy: {}, status : 0});
                                    });
                                    this.formsList = this.nameSort(this.formsList);
                                }
                            },
                            (err) => {
                                console.log(err, 'err');
                            });
                        if (this.formsList) {
                            const publishedForms = [];
                            _.map(this.formsList, (form) => { if (form.status === 0) { publishedForms.push(form) } });
                            this.publishedFormsCounts = publishedForms.length;
                        }
                    } 
                }
            });

    }
    // getRawData() {
    //     this._formsListService.getRawData()
    //         .subscribe((response: any) => {
    //             const filename = 'tasks_' + this.teamName;
    //             saveAs(response, filename);
    //             console.log('File Downloaded');
    //         }, (err) => {
    //             console.log('File Download ', err);
    //         });
    // }
    createFolder(type) {
        let modalOptions: any = {
            size: 'md',
            centered: true,
            windowClass: 'md-dialog-small',
        };
        const modalRef = this.modalService.open(CreateFolderComponent, modalOptions);
        modalRef.componentInstance.type = type;
        modalRef.componentInstance.folder = (val) => {
            this._formsListService.createDirectory({ name: val }).subscribe(
                (res: any) => {
                    this.duplicateFolder = [];
                    this.showFormName = val;
                    setTimeout(() => {
                        this.showFormName = '';
                    }, 2000);
                    let folderObj = {
                        _id: res.result[0].id,
                        name: val,
                        updatedBy: {},
                        type: 'folder',
                        status : 0
                    }
                    this.formsList.push(folderObj);
                    this.directories.push(folderObj);
                    this.mainDirectoryTemplates[0].templates = this.formsList;
                    this.mainDirectoryTemplates[0].directory.push(folderObj);
                    this.formsList = this.nameSort(this.formsList);
                    this.duplicateFolder.push(folderObj)
                },
                (err) => {
                    console.log(err);
                }
            )
        }
    }
    filterDirecotyTemplates(type, template) {
        if (type) {
            this.subFormArray = [];
            this.dummyTemplate = template;
            this.directoryList = true;
            this.collectionName = template.name;
            this.collectionId = template._id;
            if (this.subFormArray.length === 0) {
                _.map(this.mainDirectoryTemplates[0].directory, (form) => {
                    if (form.directory && form.directory._id && form.directory._id === template._id) {
                        this.subFormArray.push(form);
                        if (this.subFormArray) {
                            const publishedForms = [];
                            _.map(this.subFormArray, (form) => { if (form.status === 0) { publishedForms.push(form) } });
                            this.publishedFormsCounts = publishedForms.length;
                        }
                        this.subFormArray = this.nameSort(this.subFormArray);
                    }
                });
            }

            this.updateUrlWithDirectoryDetails();
        } else {
            this.collectionId = '';
            this._router.navigateByUrl('/formPreview/' + template._id);
        }
    }
    addExistingTemplate(type) {
        let modalOptions: any = {
            size: 'md',
            centered: true,
            windowClass: 'md-dialog-medium model-template-dialog',
        };
        const modalRef = this.modalService.open(CreateFolderComponent, modalOptions);
        modalRef.componentInstance.type = type;
        let filterTemplates = _.filter(this.mainDirectoryTemplates[0].templates, function (o) { return !o.type; });
        modalRef.componentInstance.templates = filterTemplates;
        modalRef.componentInstance.formList = (data) => {
            this.subFormArray.push(data[0]);
            let obj = {
                templateId: data[0]._id,
                directory: {
                    _id: this.dummyTemplate._id,
                    name: this.dummyTemplate.name
                }
            };
            this._formsListService.addExistingTemplates(obj).subscribe(
                (res) => {
                    this.showFormName = data.length;
                    setTimeout(() => {
                        this.showFormName = '';
                    }, 2000);
                    data[0].directory = obj.directory;
                    let dumyArray: any = [{ templates: [], directory: this.mainDirectoryTemplates[0].directory }];
                    _.forEach(this.mainDirectoryTemplates[0].templates, (value, key) => {
                        if (value.directory && !value.type) {
                            dumyArray[0].directory.push(value)
                        } else {
                            dumyArray[0].templates.push(value);
                        }
                    });
                    this.mainDirectoryTemplates = [];
                    this.mainDirectoryTemplates = dumyArray;
                    this.formsList = this.mainDirectoryTemplates[0].templates;
                    this.formsList = this.nameSort(this.formsList);
                }
            );
        }
    }

    moveTemplate(template, i) {
        let directories = [];
        if(this.collectionId != '') {
            directories.push({
                _id: '',
                name: '/'
            })
        }
        directories.push(...this.directories);
        let modalOptions: any = {
            size: 'md',
            centered: true,
            windowClass: 'md-dialog-medium model-template-dialog',
        };
        const modalRef = this.modalService.open(MoveTemplatesComponent, modalOptions);
        modalRef.componentInstance.collections = [...directories];
        modalRef.componentInstance.template = template;
        modalRef.componentInstance.collectionId = this.collectionId;

        modalRef.result.then((data) => {
            if(data) {
                if(this.collectionId == '') {
                    this.formsList.splice(i, 1);
                } else {
                    this.subFormArray.splice(i, 1);
                }
                // this.directories = _.map(this.directories, (d) => {
                //     if(d._id != this.collectionId) {
                //         return d;
                //     }
                // })
                this.removeTemplateFromDirectory(data.template);
                if(data.destination == "") {
                    this.formsList.splice(i, 0, data.template);
                    this.formsList = this.nameSort(this.formsList);
                } else {
                    this.mainDirectoryTemplates[0]['directory'].push(data.template);
                }
            }
        }, () => {
            console.log("Closed");
        })
    }

    removeTemplateFromDirectory(template) {
        let directoryIndex = _.findIndex(this.mainDirectoryTemplates[0]['directory'], (form: any) => {
            if(form._id == template._id) {
                return true
            }
        })

        if(directoryIndex != -1) {
            this.mainDirectoryTemplates[0]['directory'].splice(directoryIndex, 1);
        }

        let templateIndex = _.findIndex(this.mainDirectoryTemplates[0]['templates'], (form: any) => {
            if(form._id == template._id) {
                return true
            }
        })

        if(templateIndex != -1) {
            this.mainDirectoryTemplates[0]['templates'].splice(templateIndex, 1);
        }

        
    }

    backtoTemplate() {
        this.directoryList = false;
        this.subFormArray = [];
        this.dummyTemplate = undefined;
        this.collectionId = "";
        this.updateUrlWithDirectoryDetails();
        this.showFormName = '';
        if (this.formsList) {
            const publishedForms = [];
            _.map(this.formsList, (form) => { if (form.status === 0) { publishedForms.push(form) } });
            this.publishedFormsCounts = publishedForms.length;
        }
    }
    getFirstLetterString(name) {
        let result = '';
        let splitArray = name.split(' ');
        if (name.length === 1) {
            result = name;
        } else if (splitArray.length === 1) {
            result = splitArray[0][0] + splitArray[0][1];
        } else {
            _.forEach(splitArray, function (word) {
                result = result.concat(word[0]);
            });
        }

        return result.substring(0, 2);
    }

    getBase64String(str) {
        return 'data:image/jpg;base64,' + str;
    }

    duplicateTemplate(template_id, template_name,type) {
        // templateId
        // templateName
        let templateObj;
        if(type === 'folder'){
            templateObj = {
                templateId: template_id,
                templateName: template_name,
                appId: environment.formBuilder.appId,
                authtoken: this._authService.getAuthToken(),
                refreshtoken: this._authService.getRefreshToken(),
                directory : _.pick(this.dummyTemplate, ['_id', 'name'])
            };
        }else{
            templateObj = {
                templateId: template_id,
                templateName: template_name,
                appId: environment.formBuilder.appId,
                authtoken: this._authService.getAuthToken(),
                refreshtoken: this._authService.getRefreshToken()
            };
        }
        if (template_name === undefined || template_name === '' || (template_name && template_name.trim() === '')) {
            this.emptyTemplateError = 'Enter the form template name';
            this.duplicateTemplateError = '';
            this.maxTemplateLength = '';
        } else {
            if (template_name.length > 49) {
                this.maxTemplateLength = 'Form template name can have a max of 50 chars';
                this.emptyTemplateError = '';
                this.duplicateTemplateError = '';
                return;
            }
            this._formsListService.duplicateTemplate(templateObj).subscribe(
                (response: any) => {
                    this.closeTemplateModal();
                    $('#copylistModal').modal('toggle');
                    $('#modalTemplate').attr('data-dismiss', 'modal');
                    this._router.navigateByUrl('/formPreview/' + response.data._id);
                },
                (err) => {
                    this.duplicateTemplateError = err.error.message;
                    this.emptyTemplateError = '';
                    this.maxTemplateLength = '';
                }
            );
        }
    }
    templatePopup(templateId, templateName) {
        this.template_name = templateName,
            this.template_id = templateId;
        this.emptyTemplateError = '';
        this.duplicateTemplateError = '';
        this.templateObj = '';
        this.maxTemplateLength = '';
        $('#copylistModal').modal('toggle');
    }
    qrPreviewPopup(templateId, templateName) {
        this.previewQRID = templateId,
           this.template_name = templateName;
        $('#qrPreviewModal').modal('toggle');
    }

    closeTemplateModal() {
        this.emptyTemplateError = '';
        this.duplicateTemplateError = '';
        this.templateObj = '';
        this.maxTemplateLength = '';
    }

    templateList() {
        this.formTemplateList = true;
        this.formTemplateGrid = false;

        const dataObj = {
            type: 'WEB',
            layout: 0
        };
        this.navigateTo(dataObj);
    }

    templateGrid() {
        this.formTemplateGrid = true;
        this.formTemplateList = false;

        const dataObj = {
            type: 'WEB',
            layout: 1
        };
        this.navigateTo(dataObj);
    }

    navigateTo(dataObj) {

        this._cookieService.set('userpreferences-layout', dataObj.layout);
        this._formsListService.updateLayoutSetting(dataObj)
            .subscribe((result: any) => {
                //this._router.navigateByUrl('/formsList');
                console.log('Updated layout successfully ', result);
            },
                (err) => {
                    console.log('err ', err);
                });
    }

    deleteDirectory(directory: any, modal: TemplateRef<any>) {
        this.subFormArray = [];
        this.filterDirecotyTemplates(directory.type, directory);
        this.directoryList = false;
        this.deleteActionModalRef = this.modalService.open(modal);

        this.deleteActionModalRef.result
            .then((result: any) => {
                if(result == true) {
                    let templateIds = _.map(this.subFormArray, (form: any) => {
                        return form._id;
                    })
                    this._formsListService.deleteDirectory(directory._id, templateIds || []).subscribe((response: any) => {
                        if(response['status']) {
                            this.removeTemplateFromDirectory(directory);
                            let directoryIndex = _.findIndex(this.formsList, (form: any) => {
                                return form._id == directory._id;
                            })
                            if(directoryIndex != -1) {
                                this.formsList.splice(directoryIndex, 1);
                            }
                            if(templateIds && templateIds.length) {
                                _.forEach(this.subFormArray, (template) => {
                                    delete template.directory;
                                    this.removeTemplateFromDirectory(template);
                                    this.mainDirectoryTemplates[0]['templates'].push(template);
                                    this.formsList.push(template);
                                })
                                this.formsList = this.nameSort(this.formsList);
                            }
                        }
                    })
                }
            })
            .catch((e: any) => {
                // console.log("Closed")
            })
    }

    onCreateTempalte() {
        this.formBuilderDetails = {
            'appId': encodeURIComponent(environment.formBuilder.appId),
            'x-header-authtoken': encodeURIComponent(this._authService.getAuthToken()),
            'x-header-refreshtoken': encodeURIComponent(this._authService.getRefreshToken()),
            'redirectUrl': encodeURIComponent(window.location.href.toString()),
            'formElementsEndPoint': encodeURIComponent('/api/assets/team/')
        }

        this.formBuilderUrl = environment.formBuilder.serverUrl + '/api/v1/verifyTokens?' + 'data='
            + this.encode(this.formBuilderDetails);

        window.location.href = this.formBuilderUrl;
    }
}



// WEBPACK FOOTER //
// ./src/app/forms-list/forms-list.component.ts